/* eslint-disable */
import React from 'react';
import { MDXRenderer } from "gatsby-plugin-mdx"
import styled from 'styled-components';
import { Helmet } from 'react-helmet';
import { graphql, Link } from 'gatsby';
import PropTypes from 'prop-types';
import { MDXProvider } from "@mdx-js/react"
import moment from 'moment';

import WidthWrapper from '../components/WidthWrapper';
import Heading from '../components/Heading';
import SubHeading from '../components/SubHeading';
import Navigation from '../components/Navigation';
import ShareBar from '../components/ShareBar';
import Footer from '../sections/Footer';
import faviconPath from '../images/favicon.ico';
import ShareIconPath from '../images/icons/share.png'

const mardownH1 = styled.h1`
  margin: 40px 0 5px 0;
  color: blue;
`;

const mardownH2 = styled.h2`
  margin: 40px 0 5px 0;
  font-size: 30px;
  line-height: 35px;
  color: #2C2C2C;
`;

const mardownH3 = styled.h3`
  margin: 40px 0 5px 0;
  font-size: 20px;
  line-height: 23px;
  color: #2C2C2C;
`;

const mardownH4 = styled.h4`
  margin: 40px 0 5px 0;
  color: blue;
`;

const markdownP = styled.p`
  font-family: Roboto;
  font-size: 21px;
  line-height: 21px;
  font-weight: 400;
  color: rgba(0,0,0,0.84);
  line-height: 1.58;
  letter-spacing: -0.004em;
  word-break: break-word;
  text-rendering: optimizeLegibility;
  -webkit-font-smoothing: antialiased;
`;

const markdownBreak = styled.div`
  height: 25px;
  width: 100%;
  display: inline-block;
  position: relative;
`;

const markdonwBlockquote = styled.div`
  padding: 5px 15px 5px 15px;
  margin: 15px auto 15px 0;
  border-radius: 5px;
  background: rgba(0,168,240,0.29);
  p {
    font-size: 23px;
    color: rgba(0,0,0,0.69);
    line-height: 1.28;
    letter-spacing: -0.004em;
    word-break: break-word;
    text-rendering: optimizeLegibility;
    -webkit-font-smoothing: antialiased;
  }
`;


const Container = styled.div`
  padding: 20px 0 0 0;
  display: flex;
  flex-direction: column;
  font-family: Roboto;
`;

const HeadingContainer = styled.div`
  margin-bottom: 135px;
`;

const Date = styled.div`
  font-size: 20px;
  line-height: 23px;
  color: rgba(0, 0, 0, 0.45);
`;

const MetaContainer = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
`;

const ShareBarTop = styled(ShareBar)`
  margin-left: auto;
`;

const FooterWrapper = styled.div`
  margin-top: 150px;
`;

const BackButton = styled(Link)`
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  color: #FF9805;
  margin-top: 25px;
`;

export default function PageTemplate({ data: { mdx: post } }) {
  return (
    <Container>
    <Helmet>
      <meta charSet="utf-8" />
      <meta name="description" content={post.frontmatter.description}></meta>
      <meta name="keywords" content={post.frontmatter.keywords}></meta>
      <meta name="author" content={post.frontmatter.author}></meta>
      <title>{post.frontmatter.title} - Bidmatik</title>
      <link rel="canonical" href="https://bidmatik.com/aboutus" />
      <link rel="shortcut icon" type="image/png" href={faviconPath} />
    </Helmet>
      <Navigation />
      <WidthWrapper>
        <HeadingContainer>
          <Heading>
            {post.frontmatter.title}
          </Heading>
          <SubHeading>
            by {post.frontmatter.author}
          </SubHeading>
        </HeadingContainer>
        <MetaContainer>
          <Date>{moment(post.frontmatter.date).format('Do MMMM YYYY')}</Date>
          <ShareBarTop
            slug={post.fields.slug}
            title={post.frontmatter.title}
          />
        </MetaContainer>
        <MDXProvider
          components={{
            // Map HTML element tag to React component
            // Or define component inline
            h1: mardownH1,
            h2: mardownH2,
            h3: mardownH3,
            h4: mardownH4,
            p: markdownP,
            hr: markdownBreak,
            blockquote: markdonwBlockquote
          }}
        >
          <MDXRenderer>
            {post.body}
          </MDXRenderer>
        </MDXProvider>
        <BackButton to="/learn">
          Back To Overview
        </BackButton>
      </WidthWrapper>
      <FooterWrapper>
        <Footer showBackground />
      </FooterWrapper>
    </Container>
  )
}

export const pageQuery = graphql`
  query BlogPostQuery($id: String) {
    mdx(id: { eq: $id }) {
      id
      body
      fields {
        slug
      }
      frontmatter {
        title,
        author,
        date,
        keywords,
        description
      }
    }
  }
`